import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { GatewayDetails } from "@src/types/gateway-onboarding";

export interface QueryGatewayByIdResult {
  success: boolean;
  data?: GatewayDetails;
  error?: string;
}

export const queryGatewayByIdUseCase = async (
  gatewayId: string,
  signal?: AbortSignal,
): Promise<QueryGatewayByIdResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.getGatewayById(
      namespace,
      gatewayId,
      signal,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch gateway by ID").message,
    };
  }
};
